import React, { useState } from 'react';
import { FaShoppingCart, FaTruck } from 'react-icons/fa';

import InventorySupplier from './InventorySupplier';
import InventoryPurchases from './InventoryPurchases';

import './css/Inventory.css';
import './css/Menu.css';
import './css/MenuNav.css';
import './css/Order.css';
import './css/Purchase.css';
import './css/Receivables.css';

const Purchase = () => {
    const [purchaseSubView, setPurchaseSubView] = useState('purchases');
    const [purchasesPreselectedSupplierId, setPurchasesPreselectedSupplierId] = useState('');

    return (
        <div className="menu inventory-page purchase-page finance-page">
            <div className="menu-nav finance-nav">
                <div
                    className="menu-nav__tabs menu-nav__tabs--underline"
                    role="tablist"
                    aria-label="Purchase sections"
                >
                    <button
                        type="button"
                        role="tab"
                        aria-selected={purchaseSubView === 'supplier'}
                        className={`menu-nav__tab ${purchaseSubView === 'supplier' ? 'is-active' : ''}`}
                        onClick={() => setPurchaseSubView('supplier')}
                    >
                        <FaTruck className="menu-nav__tab-icon" aria-hidden="true" />
                        <span>Suppliers</span>
                    </button>
                    <button
                        type="button"
                        role="tab"
                        aria-selected={purchaseSubView === 'purchases'}
                        className={`menu-nav__tab ${purchaseSubView === 'purchases' ? 'is-active' : ''}`}
                        onClick={() => setPurchaseSubView('purchases')}
                    >
                        <FaShoppingCart className="menu-nav__tab-icon" aria-hidden="true" />
                        <span>Purchases</span>
                    </button>
                </div>
            </div>

            <div className="purchase-tab-panel finance-tab-panel">
                <div className="finance-content-panel">
                    {purchaseSubView === 'supplier' && (
                        <InventorySupplier
                            onSupplierCreated={(supplier) => {
                                const id = supplier?.supplierId ?? supplier?.Supplier_Id;
                                if (id != null && String(id).trim() !== '') {
                                    setPurchasesPreselectedSupplierId(String(id));
                                }
                                setPurchaseSubView('purchases');
                            }}
                        />
                    )}

                    {purchaseSubView === 'purchases' && (
                        <InventoryPurchases
                            preselectedSupplierId={purchasesPreselectedSupplierId}
                            onPreselectedSupplierConsumed={() => setPurchasesPreselectedSupplierId('')}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Purchase;
